<script>
  import tippy from "sveltejs-tippy";
  export let svgClass = "h-4 w-4 fill-current";
  export let viewBox = "0 0 512 512";
  export let disabled = false;
  export let tooltip = false;

  const props = {
    content: tooltip,
    placement: "bottom",
  };
</script>

<button
  on:click
  type="button"
  use:tippy={props}
  {disabled}
  aria-label={tooltip}
  class="relative flex cursor-pointer items-center justify-center rounded-none border-0 bg-theme-minor-700 px-2 py-1 text-center text-sm font-medium text-white opacity-90 shadow transition-opacity focus:outline-none disabled:cursor-wait hocus:opacity-100 hocus:shadow-md disabled:hocus:opacity-90"
>
  <svg xmlns="http://www.w3.org/2000/svg" {viewBox} class={svgClass}><slot /></svg>
</button>
